import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined } from '@ant-design/icons';

import {
    Layout,
    Input,
    Row,
    Typography,
    Card,
    Select,
    Collapse,
    Form,
    DatePicker,
    Col,
    InputNumber,
    Divider,
    Button,
    Modal,
    List,
    Spin
} from "antd";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import MainLayout from '../../../../../../components/layouts/MainLayout';
import TopContent from '../../../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../../../group.config";
import CustomButton from '../../../../../../components/custom/CustomButton';
import dayjs from "dayjs";
import TextArea from 'antd/es/input/TextArea';

const { Text } = Typography

const UndoDisbursal = (props) => {

    const { userData } = props;
    const { session } = userData;
    const navigate = useNavigate();
    const [useForm] = Form.useForm();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);

    function onCancel() {
        navigate("/detail-child-glim", { state: state });
    }

    const onSubmit = (formValues) => {

        const params = {
            command: "undodisbursal"
        }
        const url = `${apiConfig.Loans}/${state.loanId}`

        const body = {
            ...formValues,
            locale: "en",
            method: "POST",
            session,
            params
        };

        // return
        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
                setIsLoading(false);
            } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.undoDisbursalMsg);
                navigate("/detail-child-glim", { state: state });
                //STOP LOAD
                setIsLoading(false);
            }
        });
    };

    return (
        <MainLayout isEnableRightSidebar={true} >
            {/* PART 1  IMPORT TOP CONTENT*/}
            <TopContent
                pageTitle={labelConfig.undoDisbursal}
                pageItems={staticConfig.undoDisbursalBreadcrumbItems}
            />

            <Spin spinning={isLoading} size="large">
                <Card
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}

                    title={
                        <Row
                            style={{
                                alignContent: "center",
                                width: "8%",
                            }}
                        >
                            <Button
                                icon={<LeftOutlined />}
                                type="text"
                                style={{
                                    marginTop: "auto",
                                    marginBottom: "auto",
                                }}
                                onClick={onCancel}
                            >
                                <Text
                                    style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                                >
                                    Back
                                </Text>
                            </Button>
                        </Row>
                    }
                >
                    <Form
                        form={useForm}
                        layout="vertical"
                        onFinish={onSubmit}
                    >

                        <Row >
                            <Divider />

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.note}
                                    name={"note"}
                                >
                                    <TextArea style={{ width: "100%", height: "10vh" }} placeholder='Please enter a note' />

                                </Form.Item>
                            </Col>

                        </Row>

                        <Row>
                            <Divider />
                            {BOM.HasPermission("DISBURSALUNDO_LOAN") &&
                                <CustomButton
                                    content="Submit"
                                    style={{
                                        width: "10%",
                                        marginLeft: "auto",
                                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                    }}
                                    htmlType="submit"
                                    backgroundColor="#92428B"
                                    colorText="white"
                                    hoverBackground="#AD4EA7"
                                />}

                            <CustomButton
                                content="Cancel"
                                style={{
                                    width: "10%",
                                    marginLeft: "1%",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                backgroundColor="#fff"
                                colorText="black"
                                hoverBackground="#F5F5F5"
                                onClick={onCancel}
                            />
                        </Row>
                    </Form>
                </Card>
            </Spin>

        </MainLayout>
    )
}

export default UndoDisbursal